import i18n from '../locales/index'
import { Modal } from 'view-design'

const beforeClose = {
  before_close_normal: (resolve) => {
    Modal.confirm({
      title: i18n.t('router_before_close_1244'),
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  }
}

export default beforeClose
